<!--
	TEMPLATE
-->
<template>
<div class="editable-input">
	<div class="editable-input__brochure" :class="{'text-center': isEditView}">
		<a v-if="input && input != '...'" :href="brochureUrl" target="_blank"><i class="ico ico-pdf"></i></a>
		<span v-if="input == '...'">Generating brochure...</span>
		<span v-if="!input">No brochure uploaded</span>
	</div>

	<div v-if="isEditView">
		<s3 v-model="input" :single="true" extensions=".pdf, .PDF" label="Change Brochure"></s3>

		<span>Hint: Please submit your brochure PDF.</span>
	</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
import utils from '@/libs/mixins.js';
import vModelNested from '@/libs/vModelNested.js';
import S3 from '../../components/S3.vue';

export default {
	props: {
		value: String,
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
		}
	},
	mixins: [utils],
	components: {
		's3': S3
	},
	computed: {
		input: vModelNested,
		brochureUrl: function() {
			if(this.input != null) {
				return this.s3url(this.input);
			} else {
				return this.input;
			}
		}
	},
	methods: {
	}
}
</script>
